export const isCompanyId = subjectId => subjectId.match(/^cm_/)
